import './Tooltip.scss'
import React from 'react'

const Tooltip = ({ children }) => <div className="Tooltip">{children}</div>

export default Tooltip
